import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-the-a01-point-info-panel__header" }
const _hoisted_2 = { class: "p-the-a01-point-info-panel__heading" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "p-the-a01-point-info-panel__body" }
const _hoisted_5 = { class: "p-the-a01-point-info-panel__column" }
const _hoisted_6 = { class: "p-the-a01-point-info-panel__label-row" }
const _hoisted_7 = { class: "p-the-a01-point-info-panel__value-row" }
const _hoisted_8 = {
  class: "p-the-a01-point-info-panel__point",
  "data-translate-skip": ""
}
const _hoisted_9 = { class: "p-the-a01-point-info-panel__point-unit" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "p-the-a01-point-info-panel__expire-text" }
const _hoisted_12 = { class: "p-the-a01-point-info-panel__expire-date" }
const _hoisted_13 = {
  class: "p-the-a01-point-info-panel__expire-point",
  "data-translate-skip": ""
}
const _hoisted_14 = { class: "p-the-a01-point-info-panel__expire-point-unit" }
const _hoisted_15 = {
  key: 0,
  class: "p-the-a01-point-info-panel__column"
}
const _hoisted_16 = { class: "p-the-a01-point-info-panel__label-row" }
const _hoisted_17 = { class: "p-the-a01-point-info-panel__label" }
const _hoisted_18 = { class: "p-the-a01-point-info-panel__value-row" }
const _hoisted_19 = {
  class: "p-the-a01-point-info-panel__point",
  "data-translate-skip": ""
}
const _hoisted_20 = { class: "p-the-a01-point-info-panel__point-unit" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "p-the-a01-point-info-panel__expire-text" }
const _hoisted_23 = { class: "p-the-a01-point-info-panel__expire-date" }
const _hoisted_24 = {
  class: "p-the-a01-point-info-panel__expire-point",
  "data-translate-skip": ""
}
const _hoisted_25 = { class: "p-the-a01-point-info-panel__expire-point-unit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconInvested = _resolveComponent("IconInvested")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_HelpTooltip = _resolveComponent("HelpTooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "p-the-a01-point-info-panel",
    style: _normalizeStyle({
      '--site-color': _ctx.colorCode,
      '--site-light-color': _ctx.lightColorCode
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_IconBase, {
          class: "p-the-a01-point-info-panel__heading-icon",
          width: 32,
          height: 32,
          "view-box": "0 0 40 40",
          "icon-name": "ポイント情報"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconInvested, { "icon-color": _ctx.colorCode }, null, 8, ["icon-color"])
          ]),
          _: 1
        }),
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "p-the-a01-point-info-panel__title" }, "ポイント情報", -1))
      ]),
      _createElementVNode("a", {
        href: _ctx.urlPointConfirmation,
        class: "p-the-a01-point-info-panel__more"
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "p-the-a01-point-info-panel__more-label" }, "詳細", -1)),
        _createVNode(_component_IconBase, {
          width: 20,
          height: 20,
          "view-box": "0 0 24 24",
          "icon-color": "#fff"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconArrowRight)
          ]),
          _: 1
        })
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "p-the-a01-point-info-panel__label" }, "商品交換可能", -1)),
          (_ctx.thanksPointEnabled)
            ? (_openBlock(), _createBlock(_component_HelpTooltip, {
                key: 0,
                text: _ctx.replaceablePointText
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.addComma(_ctx.exchangePoints)), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.pointName), 1)
          ]),
          (_ctx.showExchangeExpire)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.urlExpiring,
                class: "p-the-a01-point-info-panel__expire"
              }, [
                _createElementVNode("span", _hoisted_11, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "p-the-a01-point-info-panel__expire-caption" }, "有効期限", -1)),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatExpireDate(_ctx.exchangeExpireNearestDate)), 1)
                ]),
                _createElementVNode("span", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_ctx.addComma(_ctx.exchangeExpireNearestPoints)), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.pointName), 1)
                ]),
                _createVNode(_component_IconBase, {
                  class: "p-the-a01-point-info-panel__expire-arrow",
                  width: 20,
                  height: 20,
                  "view-box": "0 0 24 24",
                  "icon-color": _ctx.colorCode
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconArrowRight)
                  ]),
                  _: 1
                }, 8, ["icon-color"])
              ], 8, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showThanksExclusive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.thanksOnlyPointName), 1),
              _createVNode(_component_HelpTooltip, { text: _ctx.thanksOnlyPointText }, null, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", _hoisted_19, [
                _createTextVNode(_toDisplayString(_ctx.addComma(_ctx.thanksExclusivePoints)), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.pointName), 1)
              ]),
              _createElementVNode("a", {
                href: _ctx.urlExpiring,
                class: "p-the-a01-point-info-panel__expire"
              }, [
                _createElementVNode("span", _hoisted_22, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "p-the-a01-point-info-panel__expire-caption" }, "贈与期限", -1)),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formatExpireDate(_ctx.thanksExclusiveExpireNearestDate)), 1)
                ]),
                _createElementVNode("span", _hoisted_24, [
                  _createTextVNode(_toDisplayString(_ctx.addComma(_ctx.thanksExclusiveExpireNearestPoints)), 1),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.pointName), 1)
                ]),
                _createVNode(_component_IconBase, {
                  class: "p-the-a01-point-info-panel__expire-arrow",
                  width: 20,
                  height: 20,
                  "view-box": "0 0 24 24",
                  "icon-color": _ctx.colorCode
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconArrowRight)
                  ]),
                  _: 1
                }, 8, ["icon-color"])
              ], 8, _hoisted_21)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
}